import React, { useState } from 'react';
import { FloatingFilter } from './floating-filter';

const MobileLayout = ({children, onSort, filterOptions}) => {
  // eslint-disable-next-line
  const [filtered, setFiltered] = useState(false)

  return (
    <>
      {children}

      <FloatingFilter
        onSort={onSort}
        onSubmit={() => setFiltered(true)}
        filterOptions={filterOptions}
      />
    </>
  )
}

export default MobileLayout
